import ContentLoader from '@space-core/components/contentLoader'
import { customMedia } from '@space-core/styles'
import { ERROR_CONTENT_LOADER_AMOUNT } from '@space-shell/modules/products/components/productCard/constants'
import styled from 'styled-components'

const Container = styled.div`
  aspect-ratio: 16/9;
  overflow: hidden;
`
const GridContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  column-gap: var(--spacer-4);
  grid-auto-columns: minmax(9.7rem, 1fr);
  max-width: calc(100vw - (var(--spacer-2) * 2));
  grid-template-columns: repeat(auto-fill, minmax(9.7rem, 1fr));

  ${customMedia.greaterThan('sm')`
    grid-template-columns: repeat(6, minmax(16rem, 1fr));
  `}

  ${customMedia.greaterThan('md')`
    grid-auto-columns: auto;
    max-width: calc(100vw - 100px);
    grid-template-columns: repeat(6, minmax(17rem, 1fr));
  `}

  ${customMedia.greaterThan('lg')`
  grid-template-columns: repeat(6, minmax(19.1rem, 1fr));
  `}
`

const LineOne = styled(ContentLoader)`
  width: 77%;
  height: 1.38rem !important;
`

const LineTwo = styled(ContentLoader)`
  width: 91%;
  height: 0.65rem !important;
`

const LineThree = styled(ContentLoader)`
  width: 62%;
  height: 0.65rem !important;
`

const BundleLoader = () => {
  return (
    <div className='_overflow-hidden' data-test='bundle-loader'>
      <GridContainer>
        {Array.from({ length: ERROR_CONTENT_LOADER_AMOUNT }).map((_, index) => (
          <div data-test='bundle-loader' key={index.toString()}>
            <Container>
              <ContentLoader className='_w-full _h-full _rounded-lg' />
            </Container>

            <LineOne className='_mt-4' />
            <LineTwo className='_my-2' />
            <LineThree />
          </div>
        ))}
      </GridContainer>
    </div>
  )
}

export default BundleLoader
